import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, useMediaQuery, } from '@mui/material';
import { XClose } from '@diamond-design/icons';
import Button from '../button/Button';
import styles from './Modal.module.scss';
const ModalSize = ['xs', 'sm', 'md', 'lg', 'xl'];
const Modal = ({ title, subTitle, open, onDismiss, showCloseButton = true, onCancelPress, onSubmitPress, cancelButtonLabel = 'Cancel', submitButtonLabel = 'Confirm', childrenContainerStyle, size = 'md', stackButtons = false, children, titleStyles, subTitleStyles, actions, }) => {
    const renderCustomButton = () => {
        if (!actions || actions.length === 0)
            return null;
        return actions.map((buttonProps, index) => {
            if (buttonProps.render) {
                const CustomButton = buttonProps.render;
                return React.createElement(CustomButton, { key: `custom-button-${index}` });
            }
            return React.createElement(Button, Object.assign({ key: `action-button-${index}` }, buttonProps));
        });
    };
    const isMaxWidth390px = useMediaQuery('(max-width:390px');
    const buttonStackDirection = isMaxWidth390px || stackButtons ? 'column-reverse' : 'row';
    const hideModalHeader = !title && !showCloseButton;
    return (React.createElement(Dialog, { className: styles.dialogRoot, open: open, onClose: onDismiss, "aria-label": "modal", maxWidth: size, fullWidth: true },
        React.createElement(DialogTitle, null, hideModalHeader ? null : (React.createElement("div", { className: styles.modalHeader },
            React.createElement("div", { "aria-label": 'modal-header', style: subTitle ? { flexDirection: 'column' } : {} },
                title && (React.createElement(Typography, { "aria-label": 'modal-title', className: [styles.title, titleStyles].join(' ') }, title)),
                subTitle && (React.createElement(Typography, { "aria-label": 'modal-subtitle', className: [styles.subTitle, subTitleStyles].join(' ') }, subTitle))),
            showCloseButton && (React.createElement("div", { className: styles.iconWrapper },
                React.createElement(XClose, { "aria-label": 'close-button', onClick: onDismiss, width: 20, height: 20 })))))),
        React.createElement(DialogContent, { "aria-label": 'modal-children-container', className: [styles.childrenContainer, childrenContainerStyle].join(' ') }, children),
        React.createElement(DialogActions, { className: styles.dialogActions },
            React.createElement("div", { "aria-label": 'button-container', className: styles.buttonContainer, style: {
                    flexDirection: buttonStackDirection,
                } },
                actions && renderCustomButton(),
                onCancelPress && (React.createElement(Button, { "aria-label": 'cancel-button', className: !onSubmitPress
                        ? styles.singleCloseButtonStyle
                        : styles.closeButtonStyle, onClick: onCancelPress || onDismiss }, cancelButtonLabel)),
                onSubmitPress && (React.createElement(Button, { "aria-label": 'submit-button', className: !onCancelPress
                        ? styles.singleSubmitButtonStyle
                        : styles.submitButtonStyle, onClick: onSubmitPress || onDismiss }, submitButtonLabel))))));
};
export default Modal;
